import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  cursor: pointer;

  .dropdown {
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  &:hover .dropdown {
    opacity: 1;
  }

  &.current .dropdown {
    opacity: 1;
  }

  .trading-toggle {
    background: transparent;
    border: none;
    outline: none;
    margin: 0;
    color: ${(props) => props.theme.$gray700};
  }

  .trading-toggle i {
    font-size: 1.8rem;
    line-height: 1rem;
  }
`;
